<template>
    <div>
        <RentalInfoShell :isHistoric="true"/>
        <SingleButtonActionbar text="View Chat" @click="$router.push('/inbox')" />
    </div>
</template>

<script>
import RentalInfoShell from '@/components/rentalsListings/shared/RentalInfoShell';
import SingleButtonActionbar from '@/components/global/SingleButtonActionbar';

export default {
    components: {
        RentalInfoShell,
        SingleButtonActionbar
    }
};
</script>
